import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { toast } from 'sonner';
import './index.css';
import './styles/pf-v2.css';
import './styles/motion-system.css';
import './icons/icons.css';
import App from './App';
import { ToastProvider } from './contexts/ToastContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { isNative } from './utils/platform';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

if (isNative) {
  document.documentElement.classList.add('platform-native');
  import('@capacitor/splash-screen').then(({ SplashScreen }) => {
    SplashScreen.hide().catch(() => {});
  });
  import('./utils/nativeBootstrap').then(({ initializeNativeShell }) => {
    initializeNativeShell().catch((error) => {
      console.warn('[native] bootstrap failed:', error);
    });
  });
} else {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.info('[PWA] App is ready for offline use.');
    },
    onUpdate: () => {
      toast.info('A new version of PetsFostering is available.', {
        action: {
          label: 'Refresh',
          onClick: () => window.location.reload(),
        },
        duration: Infinity,
      });
    },
  });
}